module.exports = __webpack_public_path__ + "img/okx.d3993121.png";